import { render } from "./ChipMultiselect.vue?vue&type=template&id=7d215531"
import script from "./ChipMultiselect.vue?vue&type=script&lang=js"
export * from "./ChipMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__